import { useAtom, atom } from 'jotai'
import { getUserInfo } from "../../api/api";
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

const userNameAtom = atom("");
const userNameKanaAtom = atom("");
const seiAtom = atom("");
const meiAtom = atom("");
const seiYomiAtom = atom("");
const meiYomiAtom = atom("");
const companyNameAtom = atom("");
const divisionNameAtom = atom("");
const emailAtom = atom("");
const telNoAtom = atom("");
const flgAtom = atom(0);
const dataAtom = atom(null);
const fccNewsAtom = atom();
const checkBoxAtom = atom(false);

const style = {
    maxWidth: '70%'
}

const UNSELECT = "";

function MainComponent({ handleLoading }) {

    document.title = "利用者情報変更| ファーストコンタクトセンター";
    let imageUrl = require("../../images/popup.png");
    let location = useLocation();
    const [data, setData] = useAtom(dataAtom);
    const [fccNews, setFccNews] = useAtom(fccNewsAtom);
    const [checkBox, setCheckBox] = useAtom(checkBoxAtom);
    const navigate = useNavigate();
    const [userName, setUserName] = useAtom(userNameAtom);
    const [userNameKana, setUserNameKana] = useAtom(userNameKanaAtom);
    const [sei, setSei] = useAtom(seiAtom);
    const [mei, setMei] = useAtom(meiAtom);
    const [seiYomi, setSeiYomi] = useAtom(seiYomiAtom);
    const [meiYomi, setMeiYomi] = useAtom(meiYomiAtom);
    const [companyName, setCompanyName] = useAtom(companyNameAtom);
    const [divisionName, setDivisionName] = useAtom(divisionNameAtom);
    const [email, setEmail] = useAtom(emailAtom);
    const [telNo, setTelNo] = useAtom(telNoAtom);
    const [flg, setFlg] = useAtom(flgAtom);
    if (!location.state) {
        location.state = { page: false };
    }

    const initInput = () => {
        setCheckBox(false);
        setUserName(UNSELECT);
        setUserNameKana(UNSELECT);
        setSei(UNSELECT);
        setMei(UNSELECT);
        setSeiYomi(UNSELECT);
        setMeiYomi(UNSELECT);
        setCompanyName(UNSELECT);
        setDivisionName(UNSELECT);
        setEmail(UNSELECT);
        setTelNo(UNSELECT);
        location.state.page = false;
    }

    if (location.state.page === true) {
        initInput();
        getUserInfo().then((resp) => {
            if (resp !== false) {
                setData(resp);
                setUserName(resp.sei + resp.mei);
                setUserNameKana(resp.seiYomi + resp.meiYomi);
                setSei(resp.sei);
                setMei(resp.mei);
                setSeiYomi(resp.seiYomi);
                setMeiYomi(resp.meiYomi);
                setCompanyName(resp.companyName);
                setDivisionName(resp.departmentName);
                setEmail(resp.email);
                setTelNo(resp.telNo);
                setFlg(resp.newsFlg);
            } else {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
                navigate("/inquiry_status");
            }
            handleLoading(false);
        })

    }

    const kanaValidation = (text) => {
        // Unicodeの30A0～30FFをカタカナとする
        const katakanaRegex = /^[゠-ヿ]+$/;
        return katakanaRegex.test(text);
    }

    const telValidation = (text) => {
        const telRegex = /^[0-9/ /-]*$/;
        return telRegex.test(text);
    }

    const handleFlgChange = (event) => {
        setFccNews(event.target.value);
    }

    const handleCheckBoxChange = (event) => {
        setCheckBox(event.target.checked);
    }

    function isHankakuKanaValidation(text) {
        var reg = new RegExp(/[ｦ-ﾟ]+/);
        return reg.test(text);
    }

    const buttonReturn = () => {
        navigate("/inquiry_status", { state: { page: true } });
        initInput();
    }

    const buttonRegist = () => {

        let newDivisionName = divisionName.replace(/^\s+/g, '');
        if ((localStorage.getItem("isPB") === "true") === true) {
            if (sei.trim() === "") {
                alert("姓を、設定してください。");
                return
            }
            if (mei.trim() === "") {
                alert("名を、設定してください。");
                return
            }
            if (!isHankakuKanaValidation(sei) === false) {
                alert("姓は、半角カタカナの入力はできません。");
                return;
            }
            if (!isHankakuKanaValidation(mei) === false) {
                alert("名は、半角カタカナの入力はできません。");
                return;
            }
            if (seiYomi === "") {
                alert("フリガナ（姓）を、設定してください。");
                return
            }
            if (meiYomi === "") {
                alert("フリガナ（名）を、設定してください。");
                return
            }

            if (kanaValidation(seiYomi) === false) {
                alert("フリガナ（姓）は、全角カタカナで入力してください。");
                return;
            }
            if (kanaValidation(meiYomi) === false) {
                alert("フリガナ（名）は、全角カタカナで入力してください。");
                return;
            }
            if (newDivisionName === "") {
                alert("部署名を設定してください。");
                return;
            }
            if (!isHankakuKanaValidation(divisionName) === false) {
                alert("部署名は、半角カタカナの入力はできません。");
                return;
            }
            if (telNo === "") {
                alert("電話番号を設定してください。");
                return;
            }

            if (telValidation(telNo) === false) {
                alert("電話番号の形が間違っています。");
                return;
            }
        }
        if (checkBox !== true) {
            alert("個人情報取得の同意にチェックしてください。");
            return;
        }
        if (fccNews === undefined) {
            if ((localStorage.getItem("isPB") === "true") === true) {
                navigate("/user_info_confirm", {
                    state: {
                        userName,
                        userNameKana,
                        companyName,
                        divisionName: divisionName ? divisionName.trim() : divisionName,
                        email,
                        telNo,
                        fccNews: flg,
                        sei: sei ? sei.trim() : sei,
                        mei: mei ? mei.trim() : mei,
                        seiYomi: seiYomi ? seiYomi.trim() : seiYomi,
                        meiYomi: meiYomi ? meiYomi.trim() : meiYomi,
                        page: false
                    }
                });
                setCheckBox(false);
            } else {
                navigate("/user_info_confirm", {
                    state: {
                        userName,
                        userNameKana,
                        companyName,
                        divisionName,
                        email,
                        telNo,
                        fccNews: flg,
                        sei: data.sei,
                        mei: data.mei,
                        seiYomi: data.seiYomi,
                        meiYomi: data.meiYomi,
                        page: false
                    }
                });
                setCheckBox(false);
            }
        } else {
            if ((localStorage.getItem("isPB") === "true") === true) {
                navigate("/user_info_confirm", {
                    state: {
                        userName,
                        userNameKana,
                        companyName,
                        divisionName: divisionName ? divisionName.trim() : divisionName,
                        email,
                        telNo,
                        fccNews,
                        sei: sei,
                        mei: mei,
                        seiYomi: seiYomi ? seiYomi.trim() : seiYomi,
                        meiYomi: meiYomi ? meiYomi.trim() : meiYomi,
                        page: false
                    }
                });
                setCheckBox(false);
            } else {
                navigate("/user_info_confirm", {
                    state: {
                        userName,
                        userNameKana,
                        companyName,
                        divisionName,
                        email,
                        telNo,
                        fccNews,
                        sei: data.sei,
                        mei: data.mei,
                        seiYomi: data.seiYomi,
                        meiYomi: data.meiYomi,
                        page: false
                    }
                });
                setCheckBox(false);
            }
        }
    }


    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>利用者情報変更</span>
                    </h2>
                    <div className="mod-list-02 of-notice">
                        <ul className="list">
                            <li>
                                <span className="mark"><em>※</em></span>
                                <div className="content">
                                    <div className="mod-txt">
                                        <p><em><b>
                                            利用者情報はPartner's BridgeまたはDWPより提供された情報を用いてログイン時に自動更新します。<br />
                                            提供された情報が空値である場合のみ、利用者情報が更新されないため、当画面から修正して下さい。<br />
                                        </b></em></p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <span className="mark"><em>※</em></span>
                                <div className="content">
                                    <div className="mod-txt">
                                        <p><em><b>
                                            同じメールアドレスを利用してPartner's Bridge及びDWPのアカウントの両方にログインする場合、<br />
                                            FCCニュースの配信する／配信しないの設定はもう一方のログイン情報にも自動で反映されます。
                                        </b></em></p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <input type="hidden" name="user_id" value="" />
                    <div id="user_info" className="mod-tbl-form mb-50">
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35"></col>
                                <col></col>
                            </colgroup>

                            {(localStorage.getItem("isPB") === "true") === true ?
                                <>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">姓<span className="required">必須</span></span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <input type="text" defaultValue={location.state.sei ? location.state.sei : sei} onChange={(e) => setSei(e.target.value)} maxLength="128" id="sei" name="sei" style={style} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">名<span className="required">必須</span></span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <input type="text" defaultValue={location.state.mei ? location.state.mei : mei} onChange={(e) => setMei(e.target.value)} maxLength="128" id="mei" name="mei" style={style} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（姓）<span className="required">必須</span></span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <input defaultValue={location.state.seiYomi ? location.state.seiYomi : seiYomi} onChange={(e) => setSeiYomi(e.target.value)} type="text" maxLength="128" id="seiyomi" name="seiyomi" style={style} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（名）<span className="required">必須</span></span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <input defaultValue={location.state.meiYomi ? location.state.meiYomi : meiYomi} onChange={(e) => setMeiYomi(e.target.value)} type="text" maxLength="128" id="meiyomi" name="meiyomi" style={style} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </>
                                : <>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">姓</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <div type="text" id="sei" name="sei" >
                                                        {location.state.sei ? location.state.sei : sei}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">名</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="mod-input">
                                                    <div type="text" id="mei" name="mei" >
                                                        {location.state.mei ? location.state.mei : mei}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>

                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（姓）</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="seiYomi" name="seiYomi">
                                                    {location.state.seiYomi ? location.state.seiYomi : seiYomi}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（名）</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="meiYomi" name="meiYomi">
                                                    {location.state.meiYomi ? location.state.meiYomi : meiYomi}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </>
                            }
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">会社名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="company_name">
                                            {location.state.companyName ? location.state.companyName : companyName}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            {(localStorage.getItem("isPB") === "true") === true ?
                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">部署名<span className="required">必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input defaultValue={location.state.divisionName ? location.state.divisionName : divisionName} onChange={(e) => setDivisionName(e.target.value)} type="text" maxLength="128" id="syozoku" name="syozoku" style={style} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                :
                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">部署名</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div id="division_name">
                                                {location.state.divisionName ? location.state.divisionName : divisionName}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            }

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">メールアドレス</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="email">
                                            {location.state.email ? location.state.email : email}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            {(localStorage.getItem("isPB") === "true") === true ?
                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">電話番号<span className="required">必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input defaultValue={location.state.telNo ? location.state.telNo : telNo.replace(/ /g, '')} onChange={(e) => setTelNo(e.target.value)} type="text" maxLength="20" id="tel" name="tel" style={style} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                : <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">電話番号</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div id="tel_no">
                                                {location.state.telNo ? location.state.telNo : telNo}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>}

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">FCCニュース<span className="required">必須</span></span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input-radio">
                                            <p id="fcc_news" className="description mb-10"></p>

                                            <ul className="list">
                                                <li>
                                                    <label>
                                                        <input type="radio" id="news_flg1" name="news_flg" value="1" checked={fccNews ? fccNews === "1" : flg === 1} onChange={handleFlgChange} /><span
                                                            className="label">配信する</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <input type="radio" id="news_flg2" name="news_flg" value="0" checked={fccNews ? fccNews === "0" : flg === 0} onChange={handleFlgChange} /><span
                                                            className="label">配信しない</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h4 className="mod-hdg-l4-02">
                        個人情報取得の同意
                    </h4>
                    <div className="mod-txt">
                        <p>個人情報の取扱いに関して <img src={imageUrl} alt="new window" className="icn" lang="en" /><Link
                            to="/handle_personal_info" target="_blank"
                            style={{ paddingLeft: "0px" }} rel="noreferrer">「NEC ファーストコンタクトセンターにおける個人情報の取扱いについて」</Link> に記載しておりますので、ご確認および同意の上、送信してください。</p>
                    </div>
                    <br></br>
                    <div className="mod-input-check">
                        <ul className="list">
                            <li><label>
                                <input type="checkbox" id="mynumber" name="mynumber" defaultValue={false} onChange={handleCheckBoxChange} />
                                <span className="label">同意する</span>
                            </label></li>
                        </ul>
                    </div>
                    <input type="hidden" id="mynumber_date" name="mynumber_date" value="" />
                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button id="btn-go-top" className="of-left" onClick={buttonReturn}>トップページへ</button>
                        </div>
                        <div className="btn">
                            <button id="btn-confirm" className="btn_default_select" onClick={buttonRegist}>登録内容で送信する</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainComponent;